"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _polished = require("polished");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _RadioButton$defaultP, _RadioButton$propType;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Label = (0, _styledComponents["default"])("label").attrs({
  className: "flexi-radio-label"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-family: ", ";\n  color: ", ";\n  margin-left: 10px;\n"])), function (props) {
  return props.theme.PrimaryFontSize;
}, function (props) {
  return props.theme.PrimaryFont;
}, function (props) {
  return props.theme.PrimaryFontColor;
});

var Wrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 5px;\n  display: ", ";\n  align-items: center;\n  height: ", ";\n  cursor: default;\n  vertical-align: top;\n  ", "\n\n    ", "\n  ", "\n  ", "\n    ", "{\n      ", "\n    }\n    ", "\n"])), function (props) {
  return props.block ? 'flex' : 'inline-flex';
}, function (props) {
  return props.height;
}, function (props) {
  return props.spaceTop && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      margin-top: ", ";\n    "])), function (props) {
    return props.spaceTop.length >= 3 ? props.spaceTop : "10px";
  });
}, function (props) {
  return props.formAlign && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      margin-top: 20px;\n    "])));
}, function (props) {
  return props.spaceLeft && (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      margin-left: ", ";\n  "])), function (props) {
    return props.spaceLeft.length >= 3 ? props.spaceLeft : "10px";
  });
}, function (props) {
  return props.spaceRight && (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      margin-right: ", ";\n    "])), function (props) {
    return props.spaceRight.length >= 3 ? props.spaceRight : "10px";
  });
}, Label, function (props) {
  return props.bold && (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        font-weight: 900;\n      "])));
}, function (props) {
  return props.disabled && (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    ", "{\n        opacity: 0.6;\n      }\n    "])), Label);
});

var RadioInput = _styledComponents["default"].input.attrs(function (props) {
  return {
    type: "radio",
    className: "flexi-radio"
  };
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  margin: 0px 4px;\n  width: ", ";\n  height: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-items: center;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border-radius: 50%;\n  ", "\n  border: ", " solid ", ";\n  outline: none;\n\n  ", "\n\n  &:checked {\n    cursor: pointer;\n    border: ", " solid \n    ", ";\n    outline: none;\n    display:flex;\n    place-content: center;\n    opacity: 0.8;\n    ", "\n    position: relative;\n\n    &:before {\n      background: ", "; \n      border-radius: 50%;\n      height: 90%;\n      width: 90%;\n      font-size: ", "px;\n      content: \"\";\n    }\n  }\n"])), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.box && (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral([" border-radius: 0; "])));
}, function (props) {
  return props.thickness;
}, function (props) {
  return props.lineColor ? props.lineColor : (0, _polished.darken)(0.2, props.theme.PrimaryBorderColor);
}, function (props) {
  return props.disabled && (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      &:disabled {\n        cursor: default;\n        border: ", " dotted\n        ", ";\n        background: ", ";\n        color: ", ";\n      }\n    "])), function (props) {
    return props.thickness;
  }, function (props) {
    return props.lineColor ? props.lineColor : (0, _polished.transparentize)(0.2, props.theme.PrimaryBorderColor);
  }, function (props) {
    return (0, _polished.transparentize)(0.8, props.lineColor ? props.lineColor : props.theme.PrimaryBorderColor);
  }, function (props) {
    return props.lineColor ? props.lineColor : props.theme.PrimaryFontColor;
  });
}, function (props) {
  return props.thickness;
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryColor;
}, function (props) {
  return props.elevate && (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n        ", ";\n      "])), function (props) {
    return props.elevate != "low" ? props.theme.Elevate[props.elevate] : props.theme.Elevate.low;
  });
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryColor;
}, function (props) {
  return parseInt(props.size) / 2.2;
});

var RadioButton = function RadioButton(props) {
  return /*#__PURE__*/_react["default"].createElement(Wrapper, props, /*#__PURE__*/_react["default"].createElement(RadioInput, props), /*#__PURE__*/_react["default"].createElement(Label, null, props.label));
};

exports.RadioButton = RadioButton;
RadioButton.defaultProps = (_RadioButton$defaultP = {
  block: false,
  spaceLeft: false,
  spaceRight: false,
  elevate: false,
  size: '24px'
}, _defineProperty(_RadioButton$defaultP, "block", false), _defineProperty(_RadioButton$defaultP, "elevate", 'mid'), _defineProperty(_RadioButton$defaultP, "height", '42px'), _defineProperty(_RadioButton$defaultP, "thickness", '2px'), _RadioButton$defaultP);
RadioButton.propTypes = (_RadioButton$propType = {
  block: _propTypes["default"].bool,
  spaceLeft: _propTypes["default"].any,
  spaceRight: _propTypes["default"].any,
  disabled: _propTypes["default"].bool,
  checked: _propTypes["default"].bool,
  name: _propTypes["default"].string,
  color: _propTypes["default"].string,
  lineColor: _propTypes["default"].string,
  radius: _propTypes["default"].string,
  label: _propTypes["default"].string,
  elevate: _propTypes["default"].any,
  size: _propTypes["default"].string,
  box: _propTypes["default"].bool
}, _defineProperty(_RadioButton$propType, "block", _propTypes["default"].bool), _defineProperty(_RadioButton$propType, "formAlign", _propTypes["default"].bool), _defineProperty(_RadioButton$propType, "bold", _propTypes["default"].bool), _defineProperty(_RadioButton$propType, "thickness", _propTypes["default"].string), _RadioButton$propType);